import { Tooltip } from 'plume-ui'
import React, { useState, useEffect } from 'react'
import {
  followCompany,
  getCompanyFollowing,
  unfollowCompany,
} from '@/lib/api/company'
import { printError } from '@/lib/log'
import { FollowButton } from '../../../../common/FollowButton'

type Props = {
  shortname: string
  isEnterprise: boolean
  showModal: () => void
  className?: string
}

export const CompanyFollowButton: React.FC<Props> = (props) => {
  const [isFollowing, setIsFollowing] = useState(false)

  useEffect(() => {
    getCompanyFollowing(props.shortname)
      .then((res) => {
        setIsFollowing(res.following)
      })
      .catch((e) => printError(e))
  }, [props.shortname])

  const follow = (shortname: string) => {
    followCompany(shortname)
      .then((res) => {
        setIsFollowing(res.following)
      })
      .catch((e) => printError(e))
  }

  const unfollow = (shortname: string) => {
    unfollowCompany(shortname)
      .then((res) => {
        setIsFollowing(res.following)
      })
      .catch((e) => printError(e))
  }

  return props.isEnterprise ? (
    <FollowButton
      isFollowed={isFollowing}
      onFollow={() => follow(props.shortname)}
      onUnfollow={() => unfollow(props.shortname)}
      className={props.className}
      theme="dark-bg"
    />
  ) : (
    <Tooltip
      className="follow-button-tooltip"
      label={'有料契約限定の機能です'}
      place="bottom"
    >
      <FollowButton
        isFollowed={false}
        onFollow={() => {
          return props.showModal()
        }}
        onUnfollow={() => {
          return false
        }}
        className={props.className}
        theme="dark-bg"
      />
    </Tooltip>
  )
}
